import React from 'react';
import { renderToString } from 'react-dom/server';
import QRImage from 'react-qr-image';
import { useDispatch, useSelector } from 'react-redux';
import bwipjs from 'bwip-js';
import * as htmlToImage from 'html-to-image';

import { ShipmentCustomer } from 'services/action';

import { Print } from 'ui/components';
import { currencyFormat, formatDate } from 'utilities/common';

import logoBlack from 'ui/assets/envio-black.png';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;

const PrintResi = ({ match, location }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['ShipmentCustomer.Show']
  );

  const [data, setData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);

  const $onLoad = async (id) => {
    const detail = await Dispatch(ShipmentCustomer.$show(id));
    if (detail?.message === 'success') {
      setData(detail?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (loaded && data) {
      setTimeout(function () {
        //   // htmlToImage
        //   //   .toBlob(document.getElementById('PRINT'))
        //   //   .then(function (blob) {
        //   //     const reader = new FileReader();
        //   //     reader.readAsDataURL(blob);
        //   //     reader.onloadend = () => {
        //   //       setImg(reader.result);
        //   //     };
        //   //   });
        //   /*
        //   reader.readAsDataURL(imageBlob);
        //   reader.onloadend = () => {
        //   const base64data = reader.result;
        //   setImg(base64data);
        // };
        // */
        htmlToImage
          .toCanvas(document.getElementById('PRINT'))
          .then(function (canvas) {
            // document.getElementsByClassName('sheet').hide();
            var x = document.getElementById('hide');
            x.style.display = 'none';
            document.body.appendChild(canvas);
          });
        // htmlToImage
        //   .toJpeg(document.getElementById('PRINT'), { quality: 1 })
        //   .then(function (dataUrl) {
        //     var x = document.getElementById('hide');
        //     x.style.display = 'none';
        //     // FireFox seems to require a setTimeout for this to work.
        //     setTimeout(() => {
        //       document.body.appendChild(document.createElement('iframe')).src =
        //         dataUrl;
        //       document.body.style.margin = 0;
        //       document.getElementsByTagName('iframe')[0].style.width = '100%';
        //       document.getElementsByTagName('iframe')[0].style.height = '100%';
        //       document.getElementsByTagName('iframe')[0].style.border = 0;
        //     }, 0);
        //     // console.log(dataUrl);
        //     // setImg(dataUrl);
        //     // var link = document.createElement('a');
        //     // link.download = `resi-${data?.code}.jpeg`;
        //     // link.href = dataUrl;
        //     // link.click().then(() => {
        //     //   window.close();
        //     // });
        //   });
      }, 200);
    }
  }, [loaded, data]);

  React.useEffect(() => {
    try {
      // The return value is the canvas element
      bwipjs.toCanvas('mycanvas', {
        bcid: 'code128', // Barcode type
        text: data?.code, // Text to encode
        scale: 1, // 3x scaling factor
        height: 12, // Bar height, in millimeters
        width: 5,
        includetext: true, // Show human-readable text
        textxalign: 'center', // Always good to set this
      });

      bwipjs.toCanvas('canvas', {
        bcid: 'code128', // Barcode type
        text: data?.code, // Text to encode
        scale: 1, // 3x scaling factor
        height: 12, // Bar height, in millimeters
        width: 5,
        includetext: true, // Show human-readable text
        textxalign: 'center', // Always good to set this
      });
    } catch (e) {}

    setLoaded(true);
  }, [data]);

  if (StateLoading && !data) return null;

  if (!loaded) return null;

  return (
    <div>
      {!data || data === null ? null : (
        <Print
          title={`Resi`}
          size="RESI"
          print={false}
          content={renderToString(
            <>
              <section className="sheet page-break" id="hide">
                <div id="PRINT" style={{ backgroundColor: '#FFFFFF' }}>
                  <div style={{ height: 325 }}>
                    <div
                      style={{
                        paddingTop: 10,
                        paddingLeft: 10,
                        paddingRight: 10,
                      }}
                    >
                      <table className="body border">
                        <tr className="border">
                          <td width={'35%'}>
                            <img
                              src={logoBlack}
                              alt=""
                              style={{ maxHeight: 25, padding: 5 }}
                            />
                          </td>
                          <td
                            colSpan={2}
                            valign="middle"
                            style={{
                              textAlign: 'right',
                              paddingRight: 10,
                              paddingTop: 5,
                            }}
                          >
                            <canvas id="mycanvas"></canvas>
                          </td>
                        </tr>

                        <tr className="border">
                          <td
                            className="border center"
                            width={'61%'}
                            colSpan={2}
                          >
                            <div className="bold elips">Distribution</div>
                          </td>
                          <td className="border center bold">
                            <div className="bold" style={{ fontSize: 10 }}>
                              COD {currencyFormat(data?.cod_value, 'IDR')}
                            </div>
                          </td>
                        </tr>

                        <tr className="border">
                          <td
                            className="border"
                            colSpan={2}
                            rowSpan={2}
                            valign="top"
                          >
                            <div style={{ height: 50 }}>
                              <div
                                style={{
                                  fontSize: 9,
                                  textTransform: 'capitalize',
                                }}
                              >
                                <b>Pengirim:</b> {data?.customer?.name},{' '}
                                <b>Telp:</b> {data?.customer?.pic_phone}
                              </div>
                              <div
                                style={{
                                  fontSize: 9,
                                  textTransform: 'uppercase',
                                  maxLines: 2,
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {data?.pickup_address?.address}
                              </div>
                            </div>
                          </td>
                          <td className="border left bold">
                            <div
                              className="bold"
                              style={{
                                fontSize: 10,
                                textTransform: 'uppercase',
                              }}
                            >
                              Ref: {data?.ref_code || '-'}
                            </div>
                          </td>
                        </tr>

                        <tr className="border">
                          <td className="border center" rowSpan={2}>
                            <div className="bold" style={{ fontSize: 20 }}>
                              {data?.recipient?.region?.regency_name}
                            </div>
                          </td>
                        </tr>

                        <tr className="border" height="40px">
                          <td className="border" colSpan={2} valign="top">
                            <div style={{ height: 60 }}>
                              <div
                                style={{
                                  fontSize: 9,
                                  textTransform: 'capitalize',
                                }}
                              >
                                <b>Penerima:</b> {data?.recipient?.name},{' '}
                                <b>Telp:</b> {data?.recipient?.phone_number}
                              </div>
                              <div
                                style={{
                                  fontSize: 9,
                                  textTransform: 'uppercase',
                                  marginTop: 3,
                                  maxLines: 2,
                                  textOverflow: 'ellipsis',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {data?.recipient?.address}
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr className="border">
                          <td className="border center">
                            <QRImage
                              text={`${POD_URL}/shipment/${data?.id}?code=${data?.code}`}
                              color="#000"
                              background="#fff"
                              style={{ height: 80 }}
                            />
                          </td>

                          <td className="border" valign="top">
                            <div style={{ fontSize: 10 }}>
                              <b>Deskripsi:</b>
                            </div>
                          </td>

                          <td className="border" valign="top">
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Tanggal:{' '}
                              {formatDate(data?.created_at, 'DD/MM/YYYY')}
                            </div>

                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Kota Asal:{' '}
                              {data?.pickup_address?.region?.regency_name}
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Berat:
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Jumlah Koli:
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div style={{ height: 151 }}>
                    <div
                      style={{
                        paddingLeft: 10,
                        paddingRight: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <table className="body border">
                        <tr className="border">
                          <td
                            className="border"
                            colSpan={2}
                            valign="middle"
                            style={{
                              textAlign: 'center',
                              paddingTop: 5,
                            }}
                          >
                            <canvas id="canvas"></canvas>
                          </td>
                        </tr>
                        <tr className="border">
                          <td
                            className="border center"
                            style={{ height: 60 }}
                            valign="center"
                            width="20%"
                          >
                            <img
                              src={logoBlack}
                              alt=""
                              style={{ maxHeight: 18, padding: 5 }}
                            />
                          </td>
                          <td
                            className="border"
                            style={{ maxHeight: 60 }}
                            valign="top"
                          >
                            <div
                              style={{
                                fontSize: 9,
                              }}
                            >
                              Ref: {data?.ref_code}
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Tanggal: {formatDate(data?.created_at)}
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Kota Asal:{' '}
                              {data?.pickup_address?.region?.regency_name}
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Berat:
                            </div>
                            <div
                              style={{
                                fontSize: 9,
                                marginTop: 3,
                              }}
                            >
                              Jumlah Koli:
                            </div>
                          </td>
                          <td className="border" width={'39%'} valign="top">
                            <div style={{ fontSize: 10, marginBottom: 10 }}>
                              <b>Pengirim:</b> {data?.customer?.name},{' '}
                              <b>Telp:</b> {data?.customer?.pic_phone}
                            </div>

                            <div style={{ fontSize: 10 }}>
                              <b>Penerima:</b> {data?.recipient?.name},{' '}
                              <b>Telp:</b> {data?.recipient?.phone_number}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        />
      )}
    </div>
  );
};

export default PrintResi;